import React from "react";

import styles from "./Checkbox.module.css";
import { ValidationError } from "../Input";

type CheckboxProps = JSX.IntrinsicElements["input"] & {
  label: string;
  error?: string;
};

export const Checkbox = React.forwardRef(
  (props: CheckboxProps, ref: React.Ref<HTMLInputElement>) => {
    return (
      <label className={styles.checkbox}>
        <input type="checkbox" ref={ref} {...props} />
        <span className={props.error && styles.errorLabel}>{props.label}</span>
        <ValidationError message={props.error} />
      </label>
    );
  },
);
